import React from 'react';
import { Icon } from 'semantic-ui-react';
import Security from '../../../../utils/Security';

const ManageJobButton = ({ job }) => {
  if (!Security.isSuperUser()) return null;

  const openManageJobPage = (event) => {
    event.preventDefault();
    event.stopPropagation();
    window.open(`${process.env.REACT_APP_ADMIN_APP_URL}/admin/jobs/${job.id}`, '_blank');
  };

  const stopEventPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <span
      role="button"
      tabIndex={0}
      aria-label="Manage job"
      onClick={openManageJobPage}
      onMouseDown={stopEventPropagation}
      onTouchStart={stopEventPropagation}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          openManageJobPage(event);
        }
      }}
      style={{
        float: 'right',
        marginLeft: '0.5rem',
        marginTop: '-0.4rem',
        width: '1.75rem',
        height: '1.75rem',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <Icon name="setting" />
    </span>
  );
};

export default ManageJobButton;
